<template>
  <div>
    <div class="content">
      <div class="element-wrapper">
        <h2>
          {{ code.haveOrg ? $t('setup_organization.welcome_to_organization') : $t('setup_organization.join_your_organization') }}
        </h2>
        <p>
          {{ code.haveOrg ? $t('setup_organization.you_can_create_own_class') : $t('setup_organization.wait_for_admin') }}
        </p>
        <div class="element">
          <img :src="!code.haveOrg ? require('@/assets/images/invitation-code-no-bg.svg') : require('@/assets/images/create-class-no-bg.svg')" />
          <primary-button @click.native="openModal">
            {{ !code.haveOrg ? $t('setup_organization.enter_invitation_code') : $t('setup_organization.create_class') }}
          </primary-button>
        </div>
      </div>
    </div>
    <join-organization
      :dialogVisible="enterInvitationCodeModal"
      v-on:closed="enterInvitationCodeModal = false"
    />
  </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import JoinOrganization from '@/components/modals/organizations/JoinOrganization'

  export default {
    components: {
      PrimaryButton,
      JoinOrganization
    },
    props: {
      code: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        enterInvitationCodeModal: false
      }
    },
    mounted() {
      // TODO: this need to be changed
      this.$store.dispatch('user/loadUserData')
    },
    methods: {
      openModal() {
        if (!this.code.haveOrg) {
          this.enterInvitationCodeModal = true
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../scss/_colors.scss';

  .content {
    display: table;
    margin: 0 auto;
    margin-top: 48px;
    min-width: 906px;
  }

  .element-wrapper {
    p {
      margin-top: 16px;
      font-size: 18px;
      color: #546873;
      line-height: 1;
      text-align: initial;
    }
    button {
      align-self: baseline;
      margin-top: 40px;
    }
    .element {
      display: flex;
      flex-direction: column;
      align-items: baseline;
      padding-top: 12px;
      button {
        width: 202px;
      }
    }
  }
</style>
